import React from 'react';
import cx from 'classnames';
import Typography from '@primitives/Typography';
import { SelectSearchResultListProps } from './types';
import styles from './SelectSearchResultList.module.scss';

const SelectSearchResultList: React.FC<SelectSearchResultListProps> = ({
    results,
    onOptionSelect,
    selectedValue,
}) => {
    let selectedIndex = -1;
    const resultValueIndexMap = new Map(results.map((result, index) => [result.value, index]));

    for (let i = 0; i < results.length; i++) {
        if (results[i].value === selectedValue) {
            selectedIndex = i;
            break;
        }
    }

    const resultsToDisplay =
        selectedIndex !== -1
            ? [
                  results[selectedIndex],
                  ...results.slice(0, selectedIndex),
                  ...results.slice(selectedIndex + 1),
              ]
            : results;

    return (
        <div className={styles['select-search-result-list-wrapper']}>
            {resultsToDisplay.map((resultItem, index) => {
                const { label, value } = resultItem;
                const selected = selectedIndex !== -1 && index === 0;
                const selectedTextColor = selected
                    ? 'var(--navi-color-blue-base)'
                    : 'var(--navi-color-gray-c1)';
                return (
                    <div
                        key={label + index}
                        className={cx(styles['result-item'], {
                            [styles['selected-item']]: selected,
                        })}
                        onClick={() => onOptionSelect(resultValueIndexMap.get(value) || 0)}
                    >
                        <Typography variant="p2" className={styles.item} color={selectedTextColor}>
                            {label}
                        </Typography>
                    </div>
                );
            })}
        </div>
    );
};

export default SelectSearchResultList;
